<div class="change-log-container pt-1 animated fadeIn">

  <!-- ═══ Loading ═══ -->
  @if (loading()) {
    <app-page-loading [absolute]="true"></app-page-loading>
  }

  @if (!loading()) {
    <div class="kite-section-card">

      <!-- ═══ Header + filter pills ═══ -->
      <div class="kite-section-title flex-wrap gap-2">
        <div class="d-flex align-items-center gap-2">
          <i class="fa fa-history mr-1"></i>
          <span>Change History</span>
        </div>
        <div class="filter-pills">
          @for (f of sectionFilters; track f.value) {
            <button
              class="pill-btn"
              [class.pill-active]="activeFilter() === f.value"
              (click)="setFilter(f.value)"
              type="button">
              {{ f.label }}
            </button>
          }
        </div>
      </div>

      <!-- ═══ Empty state ═══ -->
      @if (filteredSections().length === 0) {
        <div class="empty-state">
          <i class="fa fa-clock-o fa-2x mb-2 text-muted"></i>
          <div>
            <h6 class="mb-1 text-dark">No changes recorded yet</h6>
            <span class="text-muted">
              Edit history will appear here once changes are made to this client.
            </span>
          </div>
        </div>
      }

      <!-- ═══ Accordion ═══ -->
      <div class="accordion-list">
        @for (entry of filteredSections(); track entry.changed_at + entry.document_id; let i = $index) {

          <div class="accordion-item" [class.is-open]="expandedIndex() === i">

            <!-- ── Header (always visible) ── -->
            <div class="accordion-header" (click)="toggleEntry(i)">
              <div class="accordion-meta">
                <span [class]="getSectionBadgeClass(entry.section)">
                  {{ getSectionLabel(entry.section) }}
                </span>
                <span class="changed-by">
                  <i class="fa fa-user-o mr-1"></i>{{ entry.changed_by?.user_name || '—' }}
                </span>
                @if (expandedIndex() !== i) {
                  <span class="fields-preview">
                    {{ entry.changes.length }} field{{ entry.changes.length !== 1 ? 's' : '' }} changed
                  </span>
                }
              </div>
              <div class="accordion-right">
                <span class="changed-at">
                  <i class="fa fa-calendar-o mr-1"></i>
                  {{ entry.changed_at | date: 'MMM d, y · h:mm a' }}
                </span>
                <i class="fa fa-chevron-down chevron-icon" [class.rotated]="expandedIndex() === i"></i>
              </div>
            </div>

            <!-- ── Body (only when expanded) ── -->
            @if (expandedIndex() === i) {
              <div class="accordion-body">
                <table class="changes-table">
                  <colgroup>
                    <col style="width: 22%">
                    <col style="width: 39%">
                    <col style="width: 39%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Data field</th>
                      <th>Previous</th>
                      <th>New</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (change of entry.changes; track change.field) {
                      <tr>
                        <td class="field-name">{{ formatFieldName(change.field) }}</td>
                        <td>
                          <span class="value-chip value-old">{{ formatValue(change.previous_value, change.field) }}</span>
                        </td>
                        <td>
                          <span class="value-chip value-new-chip">{{ formatValue(change.new_value, change.field) }}</span>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }

          </div>

        }
      </div>

    </div>
  }

</div>
